import { ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from '@angular/router';


@Component({
    selector: 'app-leftsidebar',
    templateUrl: './leftsidebar.component.html',
    styleUrls: ['./leftsidebar.component.scss'],
    standalone: false
})
export class LeftsidebarComponent implements OnInit {
  @Input() activePath:string = '';
  navigatingPath: string = '';
  readonly year = new Date().getFullYear();
  // Wiki contents shown under "Wiki"; kept while moving between wiki pages.
  private static wikiTreeOpen = true;
  get wikiTreeOpen(): boolean { return LeftsidebarComponent.wikiTreeOpen; }


  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {
  }
  pagenavigation(route: string, openInNewTab?: boolean): void {
    if (openInNewTab) {
      // Respects a nested base href (e.g. /application/), unlike `/${route}`.
      const internalUrl = this.router.serializeUrl(this.router.createUrlTree([`/${route}`]));
      window.open(this.location.prepareExternalUrl(internalUrl), '_blank');
      return;
    }
    this.navigatingPath = route;
    this.router.navigate([`/${route}`]).then(() => {
      this.navigatingPath = '';
    }).catch(() => {
      this.navigatingPath = '';
    });
  }
  /** Arrow next to "Wiki": show / hide the contents tree (the row itself still opens the wiki home). */
  toggleWikiTree(event: Event): void {
    event.stopPropagation();
    LeftsidebarComponent.wikiTreeOpen = !LeftsidebarComponent.wikiTreeOpen;
  }
  openStore(): void {
    this.pagenavigation('store');
  }

}
